import { db } from '../init';

export const clearDataPointTreeBoolean = async () => {
	try {
		await db.delete().then(() => db.open());
	} catch (error) {
		console.log(error);
	}
};
